/* eslint-disable import/no-cycle */
import { Applicant } from '@flatsy/types/Applications/Applicant'
import { FetchStatus } from '@flatsy/types/FetchStatus'
import { createEntityAdapter, createSlice } from '@reduxjs/toolkit'
import { convertProStatusIntoProSituation } from '@flatsy/utils/Functions/ApplicationUtils/ProfessionalSituation/Converter'
import { OrderApplicants } from '@flatsy/utils/Functions/ApplicationUtils/OrderApplicant'
import { getApplicants, saveApplicant, saveApplicantInApplication } from './Action'
import { ApplicantsState } from './Type'

export const applicantsAdapter = createEntityAdapter<Applicant>()

// export const initialState: ApplicantsState = {
export const initialState = applicantsAdapter.getInitialState<ApplicantsState>({
  saveStatus: FetchStatus.IDLE,
  fetchStatus: FetchStatus.IDLE,
  complete: false,
})

export const applicantsSlice = createSlice({
  name: 'applicants',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    /* -------------------------------------------------------------------------- */
    /*                               SAVE APPLICANT                               */
    /* -------------------------------------------------------------------------- */
    builder.addCase(saveApplicant.fulfilled, () => {
      // nothing
    })

    /* -------------------------------------------------------------------------- */
    /*                               GET APPLICANTS                               */
    /* -------------------------------------------------------------------------- */
    builder.addCase(getApplicants.pending, (state) => {
      state.fetchStatus = FetchStatus.LOADING
    })
    builder.addCase(getApplicants.fulfilled, (state, action) => {
      const result = action.payload
      /* ---------- START ADD PROFESSIONAL SITUATION FOR MULTISTP CHOICE ---------- */
      const withFrontProfessionalSituation: Applicant[] = []
      result.forEach((element) => {
        withFrontProfessionalSituation.push({
          ...element,
          professional_situation: convertProStatusIntoProSituation(element.situation),
        })
      })
      /* ----------- END ADD PROFESSIONAL SITUATION FOR MULTISTP CHOICE ----------- */

      applicantsAdapter.setAll(state, OrderApplicants(withFrontProfessionalSituation))
      state.fetchStatus = FetchStatus.SUCCEEDED
    })
    builder.addCase(getApplicants.rejected, (state) => {
      state.fetchStatus = FetchStatus.FAILED
    })
    builder.addCase(saveApplicantInApplication.fulfilled, (state, action) => {
      if (state.entities[action.payload.id]) {
        applicantsAdapter.updateOne(state, {
          id: action.payload.id,
          changes: { ...action.payload },
        })
      }
    })
  },
})
